export class Schedule {
    StartDate: string;
    EndDate: string;

    constructor(){
       
    }
}